<template>
	<div class="right" v-if="rightShow">
		<div class="rightItem rightItem1">
			<a href="javascript:;" class="live800url" @click="$toLive800()">
				<img src="~assets/images/right_4.png" />
			</a>
		</div>
		<div class="rightItem rightItem2">
			<strong @mouseover.stop="rightItem2=true" @mouseout.stop="rightItem2=false"></strong>
			<span :class="{white:distanceToFooter2 < 0}">关注我们</span>
			<div class="rightPopup" v-show="rightItem2">
				<p>微信扫一扫<br>高考资讯早知道</p>
				<img src="~assets/images/code.png" />
			</div>
		</div>
		<div class="rightItem rightItem3">
			<strong @mouseover.stop="rightItem3=true" @mouseout.stop="rightItem3=false"></strong>
			<span :class="{white:distanceToFooter3 < 0}">小程序</span>
			<div class="rightPopup" v-show="rightItem3">
				<p>微信扫一扫<br>高考资讯早知道</p>
				<img src="~assets/images/taiyangma.png" />
			</div>
		</div>
		<div class="rightItem rightItem4" @click="scrollToTop">
			<strong @click="scrollToTop"></strong>
		</div>
	</div>
</template>

<script>
	export default {
		name: "right",
		props: {},
		data() {
			return {
				rightShow: false,
				rightItem2: false,
				rightItem3: false,
				showBackToTop: false,
				distanceToFooter2: 0, // 新增：存储距离footer的距离
				distanceToFooter3: 0, // 新增：存储距离footer的距离
			};
		},
		created() {
		},
		mounted() {
			setTimeout(() => {
				this.rightShow = true;
				this.$nextTick(() => {
					this.calculateDistanceToFooter();
				});
			}, 1000);
			window.addEventListener('scroll', this.calculateDistanceToFooter);
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.calculateDistanceToFooter);
		},
		methods: {
			calculateDistanceToFooter() {
				const rightElement2 = document.querySelector('.rightItem2');
				const rightElement3 = document.querySelector('.rightItem3');
				const footerElement = document.querySelector('.footer_view');
				
				const rightRect2 = rightElement2.getBoundingClientRect();
				const rightRect3 = rightElement3.getBoundingClientRect();
				const footerRect = footerElement.getBoundingClientRect();
				
				// 计算两个元素底部的距离
				this.distanceToFooter2 = footerRect.top - rightRect2.bottom;
				this.distanceToFooter3 = footerRect.top - rightRect3.bottom;
			},
			scrollToTop() {
				window.scrollTo({
					top: 0,
					behavior: 'smooth' // 平滑滚动
				});
			},
		},
	};
</script>

<style lang="scss" scoped>
	.right {
		width: 68px;
		position: fixed;
		bottom: 80px;
		right: 50%;
		margin-right: -702px;
		z-index: 9;

		.rightItem {
			width: 56px;
			margin: 0 auto 16px;
			position: relative;

			img {
				display: block;
				width: 56px;
				height: 56px;
			}

			span {
				width: 100%;
				padding-top: 10px;
				display: block;
				text-align: center;
				font-family: SourceHanSansCN, SourceHanSansCN;
				font-weight: 400;
				font-size: 14px;
				color: #000000;
				line-height: 14px;
				text-align: center;

				&.white {
					color: #FFFFFF;
				}
			}

			.rightPopup {
				width: 140px;
				height: 185px;
				background: #FFFFFF;
				border-radius: 3px;
				position: absolute;
				right: 72px;
				top: 0;
				padding-top: 20px;
				
				&::before{
					content: "";
					width: 5px;
					height: 5px;
					background: #D70024;
					border-radius: 5px;
					position: absolute;
					top: 13px;
					left: 130px;
				}
				
				&::after{
					content: "";
					width: 5px;
					height: 5px;
					background: #D70024;
					border-radius: 5px;
					position: absolute;
					top: 6px;
					left: 130px;
				}

				p {
					width: 140px;
					height: 40px;
					font-family: SourceHanSansCN, SourceHanSansCN;
					font-weight: 400;
					font-size: 14px;
					color: #000000;
					line-height: 20px;
					text-align: center;
					margin-bottom: 10px;
				}

				img {
					display: block;
					width: 106px;
					height: 106px;
					margin: 0 auto;
				}
			}
		}

		.rightItem1 {
			width: 68px;
			height: 62px;
			margin-bottom: 16px;
			position: relative;
			z-index: 8;

			img {
				display: block;
				width: 68px;
				height: 62px;
			}
			
			&::before{
				content: "联系我们";
				width: 65px;
				height: 21px;
				background: #D70024;
				border-radius: 12px 12px 12px 0px;
				font-size: 12px;
				text-align: center;
				line-height: 21px;
				position: absolute;
				top: -11px;
				right: -54px;
				color: #FFFFFF;
			}
		}
		.rightItem2{
			strong{
				display: block;
				width: 56px;
				height: 56px;
					background: url(../assets/images/right_1.png) no-repeat;
					background-size: cover;
				
				&:hover{
					background: url(../assets/images/right_1_1.png) no-repeat;
					background-size: cover;
				}
			}
		}
		.rightItem3{
			strong{
				display: block;
				width: 56px;
				height: 56px;
					background: url(../assets/images/right_2.png) no-repeat;
					background-size: cover;
				
				&:hover{
					background: url(../assets/images/right_2_1.png) no-repeat;
					background-size: cover;
				}
			}
		}
		.rightItem4 {
			cursor: pointer;
			strong{
				display: block;
				width: 56px;
				height: 56px;
					background: url(../assets/images/right_3.png) no-repeat;
					background-size: cover;
				
				&:hover{
					background: url(../assets/images/right_3_1.png) no-repeat;
					background-size: cover;
				}
			}
		}
	}
</style>
